import React from "react";

import { formulaStyle } from "./styles";
import Text from "./Text";

const Formula = ({ children, sm = false }) => (
  <Text style={formulaStyle(sm)}>{children}</Text>
);

export default Formula;



// WEBPACK FOOTER //
// ./src/components/analysis/Formula.js